<template lang="pug">
v-data-table.elevation-2.mt-4(
  :headers="headers",
  :items="templates",
  :loading="isLoading",
  loading-text="Loading... Please wait"
)
  template(v-slot:top="")
    v-toolbar(flat="", color="white")
      v-toolbar-title Templates
      v-spacer
      v-dialog(v-model="dialog", max-width="800")
        template(v-slot:activator="{ on }")
          v-btn.mb-2(color="primary", dark="", v-on="on") Add Template
        v-card
          v-card-title
            span.headline {{ formTitle }}
          v-card-text
            v-container
              v-row
                v-col(md="8")
                  v-text-field(
                    v-model="editedItem.name",
                    label="Name",
                    outlined,
                    hide-details
                  )
                v-col(md="4")
                  v-checkbox(
                    v-model="editedItem.is_required",
                    label="Required",
                    hide-details
                  )
                v-col(md="6")
                  v-select(
                    hide-details,
                    v-model="editedItem.checks",
                    return-object,
                    multiple,
                    item-text="name",
                    outlined,
                    :items="checks",
                    label="Checks"
                  )
                v-col(md="6")
                  v-select(
                    hide-details,
                    v-model="editedItem.case_type",
                    outlined,
                    :items="caseTypes",
                    label="Case type"
                  )
                v-col(md="12")
                  v-textarea(
                    hide-details,
                    v-model="editedItem.description",
                    outlined="",
                    label="Description"
                  )
                v-col(md="12")
                  v-text-field(
                    v-model="editedItem.condition",
                    outlined="",
                    label="Condition"
                  )
          v-card-actions
            v-spacer
            v-btn(color="primary", text="", @click="close") Cancel
            v-btn(color="primary", text="", @click="save") Save
  template(v-slot:item.actions="{ item }")
    v-icon.mr-2(small="", @click="editItem(item)")
      | mdi-pencil
    v-icon(small="", @click="deleteItem(item)")
      | mdi-delete
  template(v-slot:item.name="{ value }")
    span {{ value.length > 20 ? value.substring(0, 20) + '...' : value }}
  template(v-slot:item.description="{ value }")
    span {{ value.length > 10 ? value.substring(0, 10) + '...' : value }}
  template(v-slot:item.condition="{ value }")
    span {{ value.length > 10 ? value.substring(0, 10) + '...' : value }}
</template>
<script>
import selects from "@/utils/selects.js";
export default {
  props: ["checks"],
  data: () => ({
    dialog: false,
    isLoading: false,
    caseTypes: selects.case.types,
    headers: [
      { text: "ID", value: "ID" },
      { text: "Name", align: "start", value: "name" },
      { text: "Required", value: "is_required" },
      { text: "Description", value: "description" },
      { text: "Case Type", value: "case_type" },
      { text: "Condition", value: "condition" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    templates: [],
    editedIndex: -1,
    editedItem: {
      case_type: "",
      checks: [],
      condition: "",
      description: "",
      name: "",
      is_required: false,
    },
    defaultItem: {
      case_type: "",
      checks: [],
      condition: "",
      description: "",
      name: "",
      is_required: false,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.refreshTemplates();
  },
  methods: {
    refreshTemplates() {
      this.isLoading = true;
      this.axios
        .get("/admin/documents/template")
        .then((resp) => {
          this.templates = resp.data;
        })
        .catch((e) => {
          this.$message.errorFromServer(e);
        })
        .finally(() => (this.isLoading = false));
    },

    editItem(item) {
      this.editedIndex = this.templates.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.templates.indexOf(item);
      if (confirm("Are you sure you want to delete this item?")) {
        this.templates.splice(index, 1);
        this.axios.delete("/admin/documents/template/" + item.ID);
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.templates[this.editedIndex], this.editedItem);
        var newItem = Object.assign({}, this.templates[this.editedIndex]);
        delete newItem.UpdatedAt;
        delete newItem.CreatedAt;
        this.axios.put("/admin/documents/template", newItem);
      } else {
        this.templates.push(this.editedItem);
        this.axios.post("/admin/documents/template", this.editedItem);
      }
      this.close();
    },
  },
};
</script>